module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN314_2109013373.e98c1ee8.png";